module.exports = __webpack_public_path__ + "img/material-edit.f5086079.svg";